/**
 * Generated from ch6_p12.fla
 */
export function ch6_p12(this: Ich6_p12) {
	const sparkleOne = this.sparkleOne;
	if (!sparkleOne[0] && sparkleOne.elementFactory) {
		sparkleOne[0] = sparkleOne.elementFactory(0,undefined);
	}
	if (sparkleOne[0]) {
		ch6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations1chp6_p12_sparkle11.call(sparkleOne[0] as Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations1chp6_p12_sparkle11);
		sparkleOne[0].x = 410;
		sparkleOne[0].y = 660.25;
		sparkleOne[0].width = 72.00;
		sparkleOne[0].height = 62.50;
		sparkleOne[0].alpha = 1;
		if (sparkleOne[0].onLayout) sparkleOne[0].onLayout();
	}
	if (!sparkleOne[1] && sparkleOne.elementFactory) {
		sparkleOne[1] = sparkleOne.elementFactory(1,undefined);
	}
	if (sparkleOne[1]) {
		ch6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations1chp6_p12_sparkle12.call(sparkleOne[1] as Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations1chp6_p12_sparkle12);
		sparkleOne[1].x = 416;
		sparkleOne[1].y = 655;
		sparkleOne[1].width = 104.00;
		sparkleOne[1].height = 143.00;
		sparkleOne[1].alpha = 1;
		if (sparkleOne[1].onLayout) sparkleOne[1].onLayout();
	}
	if (!sparkleOne[2] && sparkleOne.elementFactory) {
		sparkleOne[2] = sparkleOne.elementFactory(2,undefined);
	}
	if (sparkleOne[2]) {
		ch6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations1chp6_p12_sparkle13.call(sparkleOne[2] as Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations1chp6_p12_sparkle13);
		sparkleOne[2].x = 415.5;
		sparkleOne[2].y = 655;
		sparkleOne[2].width = 101.00;
		sparkleOne[2].height = 140.00;
		sparkleOne[2].alpha = 1;
		if (sparkleOne[2].onLayout) sparkleOne[2].onLayout();
	}
	if (!sparkleOne[3] && sparkleOne.elementFactory) {
		sparkleOne[3] = sparkleOne.elementFactory(3,undefined);
	}
	if (sparkleOne[3]) {
		ch6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations1chp6_p12_sparkle14.call(sparkleOne[3] as Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations1chp6_p12_sparkle14);
		sparkleOne[3].x = 415.5;
		sparkleOne[3].y = 655.75;
		sparkleOne[3].width = 132.00;
		sparkleOne[3].height = 203.50;
		sparkleOne[3].alpha = 1;
		if (sparkleOne[3].onLayout) sparkleOne[3].onLayout();
	}
	const sparkleTwo = this.sparkleTwo;
	if (!sparkleTwo[0] && sparkleTwo.elementFactory) {
		sparkleTwo[0] = sparkleTwo.elementFactory(0,undefined);
	}
	if (sparkleTwo[0]) {
		ch6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations2chp6_p12_sparkle21.call(sparkleTwo[0] as Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations2chp6_p12_sparkle21);
		sparkleTwo[0].x = 1429.25;
		sparkleTwo[0].y = 392;
		sparkleTwo[0].width = 30.50;
		sparkleTwo[0].height = 49.00;
		sparkleTwo[0].alpha = 1;
		if (sparkleTwo[0].onLayout) sparkleTwo[0].onLayout();
	}
	if (!sparkleTwo[1] && sparkleTwo.elementFactory) {
		sparkleTwo[1] = sparkleTwo.elementFactory(1,undefined);
	}
	if (sparkleTwo[1]) {
		ch6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations2chp6_p12_sparkle22.call(sparkleTwo[1] as Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations2chp6_p12_sparkle22);
		sparkleTwo[1].x = 1430.5;
		sparkleTwo[1].y = 386.25;
		sparkleTwo[1].width = 80.00;
		sparkleTwo[1].height = 114.50;
		sparkleTwo[1].alpha = 1;
		if (sparkleTwo[1].onLayout) sparkleTwo[1].onLayout();
	}
	if (!sparkleTwo[2] && sparkleTwo.elementFactory) {
		sparkleTwo[2] = sparkleTwo.elementFactory(2,undefined);
	}
	if (sparkleTwo[2]) {
		ch6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations2chp6_p12_sparkle23.call(sparkleTwo[2] as Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations2chp6_p12_sparkle23);
		sparkleTwo[2].x = 1427.75;
		sparkleTwo[2].y = 384.5;
		sparkleTwo[2].width = 80.50;
		sparkleTwo[2].height = 159.00;
		sparkleTwo[2].alpha = 1;
		if (sparkleTwo[2].onLayout) sparkleTwo[2].onLayout();
	}
	if (!sparkleTwo[3] && sparkleTwo.elementFactory) {
		sparkleTwo[3] = sparkleTwo.elementFactory(3,undefined);
	}
	if (sparkleTwo[3]) {
		ch6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations2chp6_p12_sparkle24.call(sparkleTwo[3] as Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations2chp6_p12_sparkle24);
		sparkleTwo[3].x = 1435.5;
		sparkleTwo[3].y = 392;
		sparkleTwo[3].width = 103.00;
		sparkleTwo[3].height = 222.00;
		sparkleTwo[3].alpha = 1;
		if (sparkleTwo[3].onLayout) sparkleTwo[3].onLayout();
	}
	const sparkleThree = this.sparkleThree;
	if (!sparkleThree[0] && sparkleThree.elementFactory) {
		sparkleThree[0] = sparkleThree.elementFactory(0,undefined);
	}
	if (sparkleThree[0]) {
		ch6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations3chp6_p12_sparkle31.call(sparkleThree[0] as Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations3chp6_p12_sparkle31);
		sparkleThree[0].x = 214.5;
		sparkleThree[0].y = 249.25;
		sparkleThree[0].width = 149.00;
		sparkleThree[0].height = 134.50;
		sparkleThree[0].alpha = 1;
		if (sparkleThree[0].onLayout) sparkleThree[0].onLayout();
	}
	if (!sparkleThree[1] && sparkleThree.elementFactory) {
		sparkleThree[1] = sparkleThree.elementFactory(1,undefined);
	}
	if (sparkleThree[1]) {
		ch6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations3chp6_p12_sparkle32.call(sparkleThree[1] as Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations3chp6_p12_sparkle32);
		sparkleThree[1].x = 215;
		sparkleThree[1].y = 248.25;
		sparkleThree[1].width = 151.00;
		sparkleThree[1].height = 139.50;
		sparkleThree[1].alpha = 1;
		if (sparkleThree[1].onLayout) sparkleThree[1].onLayout();
	}
	if (!sparkleThree[2] && sparkleThree.elementFactory) {
		sparkleThree[2] = sparkleThree.elementFactory(2,undefined);
	}
	if (sparkleThree[2]) {
		ch6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations3chp6_p12_sparkle33.call(sparkleThree[2] as Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations3chp6_p12_sparkle33);
		sparkleThree[2].x = 214.5;
		sparkleThree[2].y = 237.25;
		sparkleThree[2].width = 149.00;
		sparkleThree[2].height = 158.50;
		sparkleThree[2].alpha = 1;
		if (sparkleThree[2].onLayout) sparkleThree[2].onLayout();
	}
	if (!sparkleThree[3] && sparkleThree.elementFactory) {
		sparkleThree[3] = sparkleThree.elementFactory(3,undefined);
	}
	if (sparkleThree[3]) {
		ch6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations3chp6_p12_sparkle34.call(sparkleThree[3] as Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations3chp6_p12_sparkle34);
		sparkleThree[3].x = 214.25;
		sparkleThree[3].y = 224.75;
		sparkleThree[3].width = 164.50;
		sparkleThree[3].height = 197.50;
		sparkleThree[3].alpha = 1;
		if (sparkleThree[3].onLayout) sparkleThree[3].onLayout();
	}
	const bg = this.bg;
	ch6_p12_hh_ch6_72dpi_p012psdAssetchp6_p12_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const hands = this.hands;
	ch6_p12_hh_ch6_72dpi_p012psdAssetchp6_p12_hands.call(this.hands);
	hands.x = 793;
	hands.y = 368;
	hands.width = 1083.00;
	hands.height = 736.00;
	hands.alpha = 1.00;
	if (hands.onLayout) hands.onLayout();
	const rain = this.rain;
	ch6_p12_hh_ch6_72dpi_p012psdAssetchp6_p12_rain.call(this.rain);
	rain.x = 779.75;
	rain.y = 384;
	rain.width = 1381.50;
	rain.height = 768.00;
	rain.alpha = 1.00;
	if (rain.onLayout) rain.onLayout();
	const sparkles = this.sparkles;
	ch6_p12_hh_ch6_72dpi_p012psdAssetchp6_p12_particlessparkles.call(this.sparkles);
	sparkles.x = 847.75;
	sparkles.y = 399;
	sparkles.width = 1367.50;
	sparkles.height = 574.00;
	sparkles.alpha = 1.00;
	if (sparkles.onLayout) sparkles.onLayout();
	const glow = this.glow;
	ch6_p12_hh_ch6_72dpi_p012psdAssetchp6_p12_particlesglow.call(this.glow);
	glow.x = 845.25;
	glow.y = 401;
	glow.width = 1383.50;
	glow.height = 593.00;
	glow.alpha = 1.00;
	if (glow.onLayout) glow.onLayout();
	const frameRight = this.frameRight;
	ch6_p12_hh_ch6_72dpi_p012psdAssetchp6_p12_wcframeRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 354.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const frameLeft = this.frameLeft;
	ch6_p12_hh_ch6_72dpi_p012psdAssetchp6_p12_wcframeLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 342.50;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	return this;
}
function ch6_p12_hh_ch6_72dpi_p012psdAssetchp6_p12_bg(this: Ich6_p12_hh_ch6_72dpi_p012psdAssetchp6_p12_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p12_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p12_hh_ch6_72dpi_p012psdAssetchp6_p12_hands(this: Ich6_p12_hh_ch6_72dpi_p012psdAssetchp6_p12_hands) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p12_hands", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p12_hh_ch6_72dpi_p012psdAssetchp6_p12_rain(this: Ich6_p12_hh_ch6_72dpi_p012psdAssetchp6_p12_rain) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p12_rain", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations1chp6_p12_sparkle11(this: Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations1chp6_p12_sparkle11) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p12_sparkle11", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations1chp6_p12_sparkle12(this: Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations1chp6_p12_sparkle12) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p12_sparkle12", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations1chp6_p12_sparkle13(this: Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations1chp6_p12_sparkle13) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p12_sparkle13", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations1chp6_p12_sparkle14(this: Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations1chp6_p12_sparkle14) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p12_sparkle14", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations2chp6_p12_sparkle21(this: Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations2chp6_p12_sparkle21) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p12_sparkle21", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations2chp6_p12_sparkle22(this: Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations2chp6_p12_sparkle22) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p12_sparkle22", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations2chp6_p12_sparkle23(this: Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations2chp6_p12_sparkle23) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p12_sparkle23", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations2chp6_p12_sparkle24(this: Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations2chp6_p12_sparkle24) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p12_sparkle24", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations3chp6_p12_sparkle31(this: Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations3chp6_p12_sparkle31) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p12_sparkle31", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations3chp6_p12_sparkle32(this: Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations3chp6_p12_sparkle32) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p12_sparkle32", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations3chp6_p12_sparkle33(this: Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations3chp6_p12_sparkle33) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p12_sparkle33", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations3chp6_p12_sparkle34(this: Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations3chp6_p12_sparkle34) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p12_sparkle34", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p12_hh_ch6_72dpi_p012psdAssetchp6_p12_particlessparkles(this: Ich6_p12_hh_ch6_72dpi_p012psdAssetchp6_p12_particlessparkles) {
	if (this.setLayoutTexture) this.setLayoutTexture("sparkles", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p12_hh_ch6_72dpi_p012psdAssetchp6_p12_particlesglow(this: Ich6_p12_hh_ch6_72dpi_p012psdAssetchp6_p12_particlesglow) {
	if (this.setLayoutTexture) this.setLayoutTexture("glow", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p12_hh_ch6_72dpi_p012psdAssetchp6_p12_wcframeRframe(this: Ich6_p12_hh_ch6_72dpi_p012psdAssetchp6_p12_wcframeRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch6_p12_hh_ch6_72dpi_p012psdAssetchp6_p12_wcframeLframe(this: Ich6_p12_hh_ch6_72dpi_p012psdAssetchp6_p12_wcframeLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
interface Ich6_p12Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich6_p12Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich6_p12Sprite extends Ich6_p12Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich6_p12Text extends Ich6_p12Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich6_p12Polygon extends Array<number> {
}
interface Ich6_p12 {
	readonly sparkleOne: Ich6_p12Array<Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations1chp6_p12_sparkle11|Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations1chp6_p12_sparkle12|Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations1chp6_p12_sparkle13|Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations1chp6_p12_sparkle14>;
	readonly sparkleTwo: Ich6_p12Array<Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations2chp6_p12_sparkle21|Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations2chp6_p12_sparkle22|Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations2chp6_p12_sparkle23|Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations2chp6_p12_sparkle24>;
	readonly sparkleThree: Ich6_p12Array<Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations3chp6_p12_sparkle31|Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations3chp6_p12_sparkle32|Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations3chp6_p12_sparkle33|Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations3chp6_p12_sparkle34>;
	readonly bg: Ich6_p12_hh_ch6_72dpi_p012psdAssetchp6_p12_bg;
	readonly hands: Ich6_p12_hh_ch6_72dpi_p012psdAssetchp6_p12_hands;
	readonly rain: Ich6_p12_hh_ch6_72dpi_p012psdAssetchp6_p12_rain;
	readonly sparkles: Ich6_p12_hh_ch6_72dpi_p012psdAssetchp6_p12_particlessparkles;
	readonly glow: Ich6_p12_hh_ch6_72dpi_p012psdAssetchp6_p12_particlesglow;
	readonly frameRight: Ich6_p12_hh_ch6_72dpi_p012psdAssetchp6_p12_wcframeRframe;
	readonly frameLeft: Ich6_p12_hh_ch6_72dpi_p012psdAssetchp6_p12_wcframeLframe;
}
interface Ich6_p12_hh_ch6_72dpi_p012psdAssetchp6_p12_bg extends Ich6_p12Sprite {
}
interface Ich6_p12_hh_ch6_72dpi_p012psdAssetchp6_p12_hands extends Ich6_p12Sprite {
}
interface Ich6_p12_hh_ch6_72dpi_p012psdAssetchp6_p12_rain extends Ich6_p12Sprite {
}
interface Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations1chp6_p12_sparkle11 extends Ich6_p12Sprite {
}
interface Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations1chp6_p12_sparkle12 extends Ich6_p12Sprite {
}
interface Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations1chp6_p12_sparkle13 extends Ich6_p12Sprite {
}
interface Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations1chp6_p12_sparkle14 extends Ich6_p12Sprite {
}
interface Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations2chp6_p12_sparkle21 extends Ich6_p12Sprite {
}
interface Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations2chp6_p12_sparkle22 extends Ich6_p12Sprite {
}
interface Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations2chp6_p12_sparkle23 extends Ich6_p12Sprite {
}
interface Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations2chp6_p12_sparkle24 extends Ich6_p12Sprite {
}
interface Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations3chp6_p12_sparkle31 extends Ich6_p12Sprite {
}
interface Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations3chp6_p12_sparkle32 extends Ich6_p12Sprite {
}
interface Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations3chp6_p12_sparkle33 extends Ich6_p12Sprite {
}
interface Ich6_p12_hh_ch6_72dpi_p012psdAssetsparkleanimations3chp6_p12_sparkle34 extends Ich6_p12Sprite {
}
interface Ich6_p12_hh_ch6_72dpi_p012psdAssetchp6_p12_particlessparkles extends Ich6_p12Sprite {
}
interface Ich6_p12_hh_ch6_72dpi_p012psdAssetchp6_p12_particlesglow extends Ich6_p12Sprite {
}
interface Ich6_p12_hh_ch6_72dpi_p012psdAssetchp6_p12_wcframeRframe extends Ich6_p12Sprite {
}
interface Ich6_p12_hh_ch6_72dpi_p012psdAssetchp6_p12_wcframeLframe extends Ich6_p12Sprite {
}
